// extracted by mini-css-extract-plugin
export default {"list":"LanguageChange_list__t1zZa","label":"LanguageChange_label__Md6ll","checkIcon":"LanguageChange_checkIcon__zp6Lr"};